import React, { useEffect, useState } from 'react';
import { withStyles } from '@material-ui/styles';
import flowRight from 'lodash.flowright';
import { connect } from 'react-redux';
import styles from '../styles/informationSection';
import { isDefined } from '../../../utils/isDefined';
import withUserCheck from '../../../utils/withUserCheck';
import withSettings from '../../../utils/withSettings';
import Optional from '../../../utils/optional';
import DataInputBox from '../../../partials/dataBox/DataInputBox';
import { translate } from '../../../i18n/I18nProvider';
import DataSelect from '../../../partials/dataBox/DataSelect';
import DataCheckboxRow from '../../../partials/dataBox/DataCheckboxRow';
import createCountryOptions from '../../../partials/createAddress/actions/createCountryOptions';
import createTimeZonesOptions from '../actions/createTimeZonesOptions';

const TelephonyUsersMainSection = ({
  classes,
  form,
  selectsOptions = {},
  generaldata = {},
  settings,
  defaultSettings,
  lang
}) => {
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [timeZonesOptions, setTimeZonesOptions] = useState([]);

  useEffect(() => {
    createCountryOptions({ lang, setCountriesOptions });
    createTimeZonesOptions({ setTimeZonesOptions });
  }, [lang, setCountriesOptions]);

  return (
    <div className={classes.root}>
      <div className={classes.label}>{translate('EDIT.INFO')}</div>
      <div className={classes.container}>
        <div className={classes.row}>
          <DataInputBox
            label={translate('TABLE.USERNAME')}
            name="mitelUserId"
            disabled={isDefined(generaldata.mitelUserId) ? true : false}
            infoIcon={true}
            infoIconText={translate('TOOLTIP.USERNAME_INFO')}
            width={280}
            {...form}
          />
          <DataInputBox
            label={translate('USER.CUSTOM_ID')}
            name="custom_id"
            infoIcon={true}
            infoIconText={translate('TOOLTIP.CUSTOM_USER_ID', {
              name: Optional(settings?.title).or(defaultSettings?.title)
            })}
            width={280}
            {...form}
          />
        </div>
        <div className={classes.row}>
          <DataInputBox
            label={translate('REQUEST_NEW_USER.FIRST_NAME')}
            name="firstName"
            width={280}
            {...form}
          />
          <DataInputBox
            label={translate('REQUEST_NEW_USER.LAST_NAME')}
            name="lastName"
            width={280}
            {...form}
          />
        </div>
        <div className={classes.row}>
          <DataInputBox
            label={translate('TABLE.EMAIL')}
            name="email"
            width={280}
            {...form}
          />

          <DataInputBox
            label={translate('TABLE.DEPARTMENT')}
            name="department"
            width={280}
            {...form}
          />
        </div>
        <div className={classes.row}>
          <DataInputBox
            label={translate('REQUEST_NEW_USER.COST_CENTER')}
            name="cost_center"
            width={280}
            {...form}
          />

          <DataInputBox
            label="User profile"
            name="user_profile"
            width={280}
            disabled={true}
            {...form}
          />
        </div>
        <div className={classes.row}>
          <DataSelect
            name="language"
            label={translate('EDIT.LANG')}
            options={selectsOptions.languages}
            width={300}
            customStyles={{ value: '300px' }}
            {...form}
          />
          <DataSelect
            name="country_code"
            label={translate('TABLE.COUNTRY')}
            options={countriesOptions}
            width={300}
            customStyles={{ value: '300px' }}
            {...form}
          />
        </div>
        <div className={classes.row}>
          <DataSelect
            name="time_zone_id"
            label={translate('TIMEZONE')}
            options={timeZonesOptions}
            width={620}
            customStyles={{ value: '620px' }}
            {...form}
          />
        </div>
        <DataCheckboxRow
          label="Authorize user search"
          name="authorize_search"
          {...form}
        />
      </div>
    </div>
  );
};

const mapStatesToProps = ({ editUser, auth }) => {
  return {
    selectsOptions: editUser.selectsOptions,
    generaldata: editUser.user.generalData,
    lang: auth.lang
  };
};

export default flowRight(
  withSettings,
  withUserCheck,
  connect(mapStatesToProps),
  withStyles(styles)
)(TelephonyUsersMainSection);
